import { ActionIcon, Group, Text } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import classes from "./SingleIssuanceWizard.module.css";

const WizardHeader = () => {
  const navigate = useNavigate();

  return (
    <header className={classes.topBar}>
      <Group justify="space-between">
        <Text fw={700} c="#003594">
          Single Issuance
        </Text>
        <Group gap="sm">
          <span className={classes.pill}>Policy Wizard</span>
          <ActionIcon
            variant="subtle"
            color="gray"
            aria-label="Close wizard"
            onClick={() => navigate(-1)}
          >
            <IconX size={18} />
          </ActionIcon>
        </Group>
      </Group>
    </header>
  );
};

export default WizardHeader;
